var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("div", { staticClass: "h2 mb-2" }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.contractsWithNotCollapse, function (contract, index) {
        return _c("div", { key: contract.msisdn }, [
          _c("div", { staticClass: "d-none d-lg-block" }, [
            _c(
              "div",
              { staticClass: "row mb-2" },
              [
                _c("zone-contracts-desktop", {
                  attrs: { contract: contract, index: index },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-block d-lg-none" }, [
            _c("div", { staticClass: "d-md-none" }, [
              _c(
                "div",
                { staticClass: "row mb-1" },
                [
                  _c("zone-contracts-mobile", {
                    attrs: { contract: contract, index: index },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-none d-md-block" }, [
              _c(
                "div",
                { staticClass: "row mb-1" },
                [
                  _c("zone-contracts-tablet", {
                    attrs: { contract: contract, index: index },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.contractsWithCollapse.length > 0
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "collapse",
                attrs: {
                  id: "contracts-collapsed-block",
                  role: "region",
                  "aria-labelledby": "collapsed-contract-header",
                },
              },
              _vm._l(_vm.contractsWithCollapse, function (contract, index) {
                return _c("div", { key: contract.msisdn }, [
                  _c("div", { staticClass: "d-none d-lg-block" }, [
                    _c(
                      "div",
                      { staticClass: "row mb-2" },
                      [
                        _c("zone-contracts-desktop", {
                          attrs: { contract: contract, index: index },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-block d-lg-none" }, [
                    _c("div", { staticClass: "d-md-none" }, [
                      _c(
                        "div",
                        { staticClass: "row mb-1" },
                        [
                          _c("zone-contracts-mobile", {
                            attrs: { contract: contract, index: index },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-none d-md-block" }, [
                      _c(
                        "div",
                        { staticClass: "row mb-1" },
                        [
                          _c("zone-contracts-tablet", {
                            attrs: { contract: contract, index: index },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: {
                    id: "collapsed-contract-header",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": "#contracts-collapsed-block",
                    "aria-controls": "contracts-collapsed-block",
                  },
                  on: { click: _vm.clickHandler },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.buttonLabel) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }